import { Box, Flex, Text } from '@chakra-ui/react'

export const ProgressBar = ({
  totalCount,
  totalLimit,
  version = 'card',
  title,
  text,
  minW = '280px',
  showTexts = true,
}: {
  totalCount: number
  totalLimit: number
  version?: 'card' | 'banner' | 'modal'
  title?: string
  text?: string
  minW?: string
  showTexts?: boolean
}) => {
  const isCardVersion = version === 'card'
  const isModalVersion = version === 'modal'

  return (
    <Box
      p={isCardVersion ? 0 : 3}
      bg={isCardVersion ? 'transparent' : { base: isModalVersion ? '#FFFFFF04' : '#FFFFFF14', xl: '#FFFFFF04' }}
      rounded={'xl'}
      w={'full'}
      minW={minW}
    >
      {showTexts && (
        <Flex fontSize={'sm'} fontWeight={700} mb={isCardVersion ? 1 : 2} justifyContent={'space-between'}>
          <Text color={isCardVersion ? 'whiteAlpha.600' : 'white'}>{title ? title : 'Available limit'}</Text>
          {text ? (
            <Text>{text}</Text>
          ) : (
            <Text color={'whiteAlpha.600'}>
              <Text
                color={'white'}
                as={'span'}
                bg={{
                  base: 'transparent',
                  xl: `linear-gradient(96.99deg, #FC5DFF 13.35%, #9C5EFF 86.25%);linear-gradient(96.99deg, color(display-p3 0.918 0.408 1.000) 13.35%, color(display-p3 0.580 0.380 1.000) 86.25%);`,
                }}
                backgroundClip={{ base: 'initial', xl: 'text' }}
                __css={{
                  '-webkit-text-fill-color': 'transparent',
                }}
              >
                {totalCount
                  ? Math.min(totalLimit - totalCount, totalLimit).toLocaleString('en-US')
                  : totalLimit.toLocaleString('en-US')}
                /{totalLimit.toLocaleString('en-US')}
              </Text>
            </Text>
          )}
        </Flex>
      )}
      <Box rounded={'full'} bg={'whiteAlpha.100'} h={isCardVersion ? '12px' : '15px'}>
        <Box
          rounded={'full'}
          overflow={'hidden'}
          h={'full'}
          w={totalCount ? ((totalLimit - totalCount) / totalLimit) * 100 + '%' : '100%'}
        >
          <Box
            boxShadow={`-1px 0px 8px 0px #FFFFFFB5 inset;0px 0px 24px -15px #FFFFFF inset;`}
            sx={{
              '@keyframes animate': {
                '0%': { bgPos: '0 0' },
                '100%': { bgPos: '-500% 0' },
              },
            }}
            animation={'animate 15s linear infinite'}
            w={'full'}
            h={'full'}
            bgGradient={`linear-gradient(100deg, #FC5DFF 0%, #9C5EFF 50%, #FC5DFF 100%);`}
            bgSize={'500%'}
          />
        </Box>
      </Box>
    </Box>
  )
}
